import clsx from 'clsx';
import * as React from 'react';

interface DotStatusProps {
	color: 'yellow' | 'red' | 'green' | 'grey' | 'orange';
}

export const DotStatus: React.FC<DotStatusProps> = ({ color }) => {
	return (
		<div
			className={clsx(
				'flex items-center justify-center rounded-full w-3 h-3 flex-shrink-0',
				{
					'green-gradient': color === 'green',
					'red-gradient': color === 'red',
					'gray-gradient': color === 'grey',
					'yellow-gradient': color === 'yellow',
					'orange-gradient': color === 'orange',
				}
			)}
		>
			<span
				className={clsx('w-2 h-2 rounded-full', {
					'bg-green-120': color === 'green',
					'bg-main-red': color === 'red',
					'bg-dark-40': color === 'grey',
					'bg-yellow-base': color === 'yellow',
					'bg-main-orange': color === 'orange',
				})}
			/>
		</div>
	);
};
